import Vue from "vue";
import Router from "vue-router";

//Pages
import Layout from '@/views/layouts/Layout.vue';
import Home from '@/views/pages/Home.vue';
import About from "@/views/pages/About.vue";
import Contact from "@/views/pages/Contact.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/",
      component: Layout,
      children: [
        {
          path: "/",
          name: "Home",
          component: Home,
        },
        {
          path: "/face",
          beforeEnter() {location.href = 'https://www.facebook.com/profile.php?id=100073973791578'}
        },
        {
          path:"/ig",
          beforeEnter(){location.href='https://www.instagram.com/_altakkk/'}
        },
        {
          path: "/aboutus",
          name: "About",
          component: About,
        },
        {
          path: "/contact",
          name: "Contact",
          component: Contact,
        },
      ],
    },
  ],
});

export default router;
